/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import { AssetOption, Folder, OptionUtils, PurchaseOptionType } from '@wit/vtv-x-foundation-lib';
import { SagaIterator } from 'redux-saga';
import Options from 'core/store/ducks/pi/options';
import { call } from 'redux-saga/effects';
import translate from '../../../../services/i18n/translate';

function setOptionTitles(options: AssetOption[]): AssetOption[] {
  return options.map((option) => {
    let titleTemplate = translate['buttons.subscriptionTo'];
    if (OptionUtils.isBundleOption(option)) {
      titleTemplate =
        option.purchaseOptionType === PurchaseOptionType.BUY
          ? translate['buttons.ownBoxSet']
          : translate['buttons.rentBoxSet'];
    }
    const assetName = option.asset?.title || '';
    return {
      ...option,
      title: translate.formatString(titleTemplate, { assetName }).toString(),
    };
  });
}

export default function* getFolderPurchasesOptions(folders: Folder[]): SagaIterator<AssetOption[]> {
  try {
    const options: AssetOption[] = yield call(Options.getFolderPurchasesOptions, folders);
    return setOptionTitles(options);
  } catch (e) {
    return [];
  }
}
